import Section from '../Section';
import HeroStyle4 from '../Hero/HeroStyle4';
import AboutSectionStyle5 from '../Section/AboutSection/AboutSectionStyle5';
import { pageTitle } from '../../helpers/PageTitle';
import Brt2025 from "../Brt2025/Brt2025";

const Career = () => {
  pageTitle("Career");

  return (
    <div>
      <HeroStyle4
        title="Find Your Dream Job Here"
        subTitle="Find your dream job here – with NHWM, become a part of a dedicated mission to promote global health, empower communities, and shape a better, healthier future for all"
        bgUrl="/images/home_3/hero_bg.svg"
        imgUrl="/images/home_4/hero_img_1.png"
        imgUrl2="/images/home_4/hero_img_2.png"
        imgUrl3="/images/home_4/hero_img_3.png"
      />
      <Section>
        <Brt2025/>
      </Section>
      <div className="mt-[-80px]">
      <Section topMd={170} topLg={120} topXl={100} bottomMd={100} >
        <AboutSectionStyle5
          imgUrl="/images/home_4/about_img.jpeg"
          titleUp="ABOUT US"
          title="The National Healthcare and Wellness Mission"
          subTitle="NHWM in partnership with Optim Health and Wellness (OPC) Pvt. Ltd., is committed to enhancing the health and well-being of people across India. Our mission is to educate, empower, and support individuals in preventing and even reversing lifestyle-related degenerative diseases through expert-led initiatives."
          supportTitle="Mon-Fri (10 AM - 4 PM)"
          supportSubTitle="We’re at your service."
        />
      </Section>
      </div>
    </div>

  );
}

export default Career